const brandPathMapping = {
  b: 'DYB',
  cb: 'CB',
  yb: 'YB',
  vm: 'VM',
};

function getBrandId() {
  const path = window.location.pathname.slice(1);
  const slashPosition = path.indexOf('/');
  const brand = slashPosition === -1 ? path : path.substring(0, slashPosition);
  window.bowBaseUrl = `${window.location.origin}/${brand}`;
  return brandPathMapping[`${brand}`.toLowerCase()];
}

function getConfig(runtimeConfig) {
  const brandId = getBrandId();
  if (brandId == null) {
    window.location.href = `${window.location.origin}/vm`;
  }
  const { common, ...brandConfigs } = runtimeConfig;
  return {
    brandId,
    ...common,
    ...brandConfigs[brandId],
  };
}

function loadConfig(runtimeConfig) {
  window.envConfig = getConfig(runtimeConfig);
  delete window.__config;
}

loadConfig(window.__config);
